export default {
    MENU_OPEN: 'MainMenuOpen',
    MENU_CLOSE: 'MainMenuClose',
};
